/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class CustomerContactSummaryVO extends JSONable {
  uuid: string | undefined = undefined;
  name: string | undefined = undefined;
  email: string | undefined = undefined;
  phoneNumber: string | undefined = undefined;
}
